<script>
import api from '@utils/api'
import apimixins from '../apimixins'
import TablePaginator from '@components/paginator'
import AdjustColumnsDialog from '@components/adjust-columns-dialog'

export default {
  name: 'ShipmentMistakes',
  components: {
    AdjustColumnsDialog,
    TablePaginator,
  },
  mixins: [apimixins],
  data() {
    return {
      modelName: 'ShipmentMistakes',
      showDialog: false,
      headers: [
        { text: 'plugGuid', value: 'serial', sortable: true },
        {
          text: 'transmitter_id',
          value: 'transmitter',
          sortable: true,
          show: true,
        },
        {
          text: 'shipped_by_document',
          value: 'expectedOrganisation',
          sortable: true,
          show: true,
        },
        { text: 'placed_in_fact', value: 'actualOrganisation', sortable: true },
        {
          text: 'shipment_time',
          value: 'shipmentTime',
          sortable: true,
          show: true,
        },
      ],
      isLoading: false,
      sortBy: 'expectedOrganisation',
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.getPaginator()
      let filters = this.getFilters()
      if (this.filtersEmpty(filters) || this.$route.params.fromNotification) {
        this.getDataSet()
      }
    },
    getDataSet() {
      this.isLoading = true
      this.prepareFilterParams()
      api.getReportData('shipment_mistakes', this.params).then(response => {
        this.setResponseParams(response)
        this.content = response.content.map(content => {
          const {
            serial,
            transmitter,
            expectedOrganisation,
            actualOrganisation,
            shipmentTime,
          } = content
          return {
            serial,
            transmitter,
            expectedOrganisation,
            actualOrganisation,
            shipmentTime,
          }
        })
        this.isLoading = false
      })
    },
  },
}
</script>

<template>
  <div>
    <v-layout justify-end>
      <v-btn
        icon
        flat
        @click="openDialog()">
        <v-icon>view_column</v-icon>
      </v-btn>
    </v-layout>
    <v-data-table
      :headers="headers"
      :items="content"
      :pagination="pagination"
      :total-items="totalElements"
      :loading="isLoading"
      :class="$style.sdTable"
      hide-actions
    >
      <template
        slot="headers"
        slot-scope="props">
        <tr>
          <th
            v-for="header in headers"
            :key="header.text"
            :class="getSortClass(header)"
            :style="[header.show === false ? {'display': 'none'} : {'text-align': 'left'}]"
            @click="changeSort(header)"
          >
            <span> {{ $t(`label__${header.text}`) }} </span>
            <v-icon
              v-if="header.sortable"
              small>expand_less
            </v-icon>
          </th>
        </tr>
      </template>
      <v-progress-linear
        slot="progress"
        height="2"
        color="blue"
        background-color="#E0E0E0"
        indeterminate
      />
      <template
        slot="items"
        slot-scope="props"
      >
        <tr>
          <td>
            <router-link
              v-if="userAllowedToNavigate"
              :to="{ name: 'searchPlug', params: { serial: props.item.serial, goodsGroup: 2 }} ">
              {{ props.item.serial }}
            </router-link>
            <span v-else> {{ props.item.serial }} </span>
          </td>
          <td v-if="!hideValues('transmitter')">
            <router-link
              v-if="userAllowedToNavigate"
              :to="{ name: 'searchPlug', params: { serial: props.item.transmitter, goodsGroup: 3 }} ">
              {{ props.item.transmitter }}
            </router-link>
            <span v-else> {{ props.item.transmitter }} </span>
          </td>
          <td v-if="!hideValues('expectedOrganisation')">
            <router-link
              v-if="userAllowedToNavigate && props.item.expectedOrganisation"
              :to="{ name: 'organization', params: { orgId: props.item.expectedOrganisation }} "> {{ getValue('organization', props.item.expectedOrganisation) }}
            </router-link>
            <span v-if="!userAllowedToNavigate && props.item.expectedOrganisation">{{ getValue('organization', props.item.expectedOrganisation) }}</span>
            <span v-if="!props.item.expectedOrganisation">{{ '-' }}</span>
          </td>
          <td>
            <router-link
              v-if="userAllowedToNavigate && props.item.actualOrganisation"
              :to="{ name: 'organization', params: { orgId: props.item.actualOrganisation }} "> {{ getValue('organization', props.item.actualOrganisation) }}
            </router-link>
            <span v-if="!userAllowedToNavigate && props.item.actualOrganisation">{{ getValue('organization', props.item.actualOrganisation) }}</span>
            <span v-if="!props.item.actualOrganisation">{{ $t('label__unknown') }}</span>
          </td>
          <td v-if="!hideValues('shipmentTime')">{{ dateFormat(props.item.shipmentTime) || '-' }}</td>
        </tr>
      </template>
    </v-data-table>
    <table-paginator
      :page="page"
      :total-pages="totalPages"
      :first="first"
      :last="last"
      :rows-per-page="pagination.rowsPerPage"
      @change-page="changePage($event)"
      @change-rows-per-page="changeRowsPerPage($event)"/>
    <adjust-columns-dialog
      v-model="showDialog"
      :headers="headers.filter(h => h.show !== undefined)"
      :model-name="modelName"
      @columns-updated="updateColumns"
    />
  </div>
</template>

<style lang="scss" module>
@import '@design';

.sdTable {
  border: 1px solid #dfdfdf;

  th {
    outline: none;
  }
}
</style>
